import { render, staticRenderFns } from "./ListaEmpresa.vue?vue&type=template&id=491324da"
import script from "./ListaEmpresa.vue?vue&type=script&lang=js"
export * from "./ListaEmpresa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports